import React, { type FC, useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import classNames from 'classnames';
import { SimpleBarOptions } from 'simplebar-react';

import { ModulesScrollbarContext } from 'app/design-system/components/Scrollbar/ModulesScrollbarContext';

import { Scrollbar, type ScrollbarProps } from './Scrollbar';

import styles from './Scrollbar.module.scss';

export type ModulesScrollbarProps = {
  isScrollReset?: boolean;
} & ScrollbarProps;

export const ModulesScrollbar: FC<ModulesScrollbarProps> = ((props) => {
  const { className, isScrollReset, ...rest } = props;
  const scrollbarRef = useRef<SimpleBarOptions>(null);

  const location = useLocation();

  useEffect(() => {
    if (!isScrollReset) {
      return;
    }

    const scrollTop = scrollbarRef.current.contentWrapperEl.scrollTop;

    if (scrollTop !== 0) {
      scrollbarRef.current.getScrollElement().scrollTop = 0;
    }
  }, [location.pathname]);

  const scrollbarClassNames = classNames(
    styles.modulesScrollbarWrapper,
    className);

  const providerValue = {
    scrollbarRef,
  };

  return (
    <ModulesScrollbarContext.Provider value={providerValue}>
      <Scrollbar className={scrollbarClassNames}
                 {...rest}
                 ref={scrollbarRef}>
        {props.children}
      </Scrollbar>
    </ModulesScrollbarContext.Provider>
  );
});

export { useModulesScrollbarContext as useModulesScrollbar } from './ModulesScrollbarContext';
